export default function Layout({ children }) {
  return (
    <>
      <div className="layout">
        {children}
        <style jsx>
          {`
            margin-top: 5rem;
          `}
        </style>
      </div>
    </>
  );
}
